<template>
  <div class="component-map-contaier">
    <div id="mapScreen"></div>
  </div>
</template>

<script>
import MAPDATA from "../../assets/map/dadukou.json";
import { formatConfig } from "../../utils/index";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      count: 0,
    };
  },
  computed: {
    ...mapGetters(["tapMapCount", "largeConfig"]),
  },
  async mounted() {
    await this.$store.dispatch("login/getLargeConfig");
    // this.onChangeMapCount();
    this.initMap(formatConfig());
  },
  watch: {
    tapMapCount(n, o) {
      if (!n) {
        // onChangeMapCount();
        this.initMap();
      }
    },
  },

  methods: {
    onChangeMapCount: function () {
      console.log("this.tapMapCount", this.tapMapCount);
      let count = this.tapMapCount + 1;
      this.$store.commit("app/SET_TAP_MAP_COUNT", count);
    },
    initMap(geoData = formatConfig()) {
      const $color = this.$color;

      var defaultLayer = new AMap.createDefaultLayer();
      // const imageLayerr = new AMap.ImageLayer({
      //   // url: "http://htech-resource.oss-cn-chengdu.aliyuncs.com/platform/J0Kk3KDMcYpjHZ2zRaPCHFZzCbHNANbBWechatIMG135.png",
      //   url: "http://htech-resource.oss-cn-chengdu.aliyuncs.com/platform/Fk5S2paCiTr6fffQe5esKEjdR4AEptBaWechatIMG136.png",
      //   bounds: new AMap.Bounds(), //图片矩形范围
      //   zooms: [4, 28],
      // });

      this.$nextTick(() => {
        var map = new AMap.Map("mapScreen", {
          // center: [106.48613, 29.481002],
          layers: [
            defaultLayer, // disCountry 跟 defaultLayer 一定要搭配使用 不然只使用 disCountry 会导致不显示省市名称
          ],
          center: [106.533104, 29.389476],
          // zoom: 10,
          // zooms: [12, 12],
          // expandZoomRange: false,
          expandZoomRange: true,
          zooms: [11, 20],
          // mapStyle: "amap://styles/darkblue",
          mapStyle: "amap://styles/4896bbf7ead59dd345ea7220fa76743f",
          // mapStyle: "amap://styles/57994c871bb604a4c79184f5f65d8782",
          // mapStyle: "amap://styles/f77928fcf0246498e79db37cea48c0d6",
        });
        // map.add(imageLayerr);

        //map.setZoom(12.2); //设置地图层级
        new AMap.DistrictSearch({
          extensions: "all",
          subdistrict: 0,
        }).search("大渡口", function (status, result) {
          // 外多边形坐标数组和内多边形坐标数组
          var outer = [
            new AMap.LngLat(-360, 90, true),
            new AMap.LngLat(-360, -90, true),
            new AMap.LngLat(360, -90, true),
            new AMap.LngLat(360, 90, true),
          ];
          var holes = result.districtList[0].boundaries;
          var pathArray = [outer];
          pathArray.push.apply(pathArray, holes);
          var polygon = new AMap.Polygon({
            pathL: pathArray,
            //线条颜色，使用16进制颜色代码赋值。默认值为#006600
            strokeColor: "rgb(20,164,173)",
            strokeWeight: 4,
            //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
            strokeOpacity: 0,
            //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
            fillColor: $color.backgroundColor,
            //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
            fillOpacity: 0.1,
            //轮廓线样式，实线:solid，虚线:dashed
            strokeStyle: "solid",
            /*勾勒形状轮廓的虚线和间隙的样式，此属性在strokeStyle 为dashed 时有效， 此属性在
              ie9+浏览器有效 取值：
              实线：[0,0,0]
              虚线：[10,10] ，[10,10] 表示10个像素的实线和10个像素的空白（如此反复）组成的虚线
              点画线：[10,2,10]， [10,2,10] 表示10个像素的实线和2个像素的空白 + 10个像素的实
              线和10个像素的空白 （如此反复）组成的虚线*/
            strokeDasharray: [10, 2, 10],
            fill: "rgba(0,0,0, 0)",
          });
          polygon.setPath(pathArray);
          map.add(polygon);
        });
        this.pictureBlock(map, geoData);

        // map.on("click", function (ev) {
        //   console.log(ev);
        //   // 触发事件的对象
        //   var target = ev.target;
        //   // 触发事件的地理坐标，AMap.LngLat 类型
        //   var lnglat = ev.lnglat;
        //   // 触发事件的像素坐标，AMap.Pixel 类型
        //   var pixel = ev.pixel;
        //   // 触发事件类型
        //   var type = ev.type;
        // });
      });
    },
    pictureBlock(map, geoData) {
      let that = this;
      if (map) {
        map.clearMap();
        //https://developer.amap.com/demo/javascript-api/example/overlayers/geojson
        var texts = {};
        // console.log("texts", MAPDATA);
        var mapGeo = new AMap.GeoJSON({
          geoJSON: geoData,
          getPolygon: function (json, lnglats) {
            if (json.properties.id == -4603) {
              return; //南海诸岛
            }
            var pol = new AMap.Polygon({
              path: lnglats,
              bubble: true, //事件冒泡
              strokeWeight: 1,
              strokeColor: that.$color.mapColor,
              fillColor: that.$color.mapColor,
              fillOpacity: 0.3,
            });

            if (lnglats.length) {
              var prop = json.properties;

              prop = prop._parentProperities || prop;
              var obj = texts[prop.unique_id] || { pols: [] };
              obj.name = prop.name;
              obj.data = prop;
              obj.pols.push({
                pos: pol.getBounds().getCenter(),
                size: pol.getArea(),
                pol: pol,
              });
              texts[prop.unique_id] = obj;
            }

            return pol;
          },
        });
        map.add(mapGeo);

        //显示名称
        for (var k in texts) {
          (function () {
            var o = texts[k];
            o.pols.sort(function (a, b) {
              return b.size - a.size;
            });
            var center = o.pols[0].pos,
              dCP = o.data.cp; //指定了名字显示坐标
            if (dCP && dCP.splice && +dCP[0] && +dCP[1]) {
              center = new AMap.LngLat(+dCP[0], +dCP[1]);
            }
            var txt = new AMap.Text({
              map: map,
              bubble: true, //事件冒泡
              text: o.name,
              position: center,
              style: {
                color: that.$color.mapTextColor,
                border: "none",
                background: "none",
                fontSize: "13px",
                fontWeight: "bold",
              },
              extData: o.data,
            });
            txt.on("click", function (e) {
              if (window.mapDistanceIsOpen) return;
              var o = e.target.getExtData();
              that.onChangeMapCount();
              console.log("amap click", o);
              console.log("that.tapMapCount", that.tapMapCount);
              let features = MAPDATA.features;
              features = features.filter(
                (v) => v.properties.unique_id == o.unique_id
              );
              if (
                that.tapMapCount >= 2 ||
                that.largeConfig.subDistricts.length == 1
              ) {
                that.$emit("clickMap", {
                  key: "street",
                  rowKey: o.name,
                  level: 2,
                });
              } else {
                // that.$emit("clickMap", {
                //   key: "main",
                //   rowKey: o.name,
                //   level: 1,
                // });
                that.$store.dispatch("app/changeMapKey", o.name);
                that.$store.dispatch("app/getGlobalData").then((resp) => {
                  if (!resp) {
                    // this.visibleEmpty = true;
                    that.$store.commit("app/SET_KEY", "main");
                    return;
                  } else {
                    that.initMap({ ...MAPDATA, features });
                  }
                });
              }
            });
            txt.on("mouseover", function () {
              console.log("执行成功");

              if (window.mapDistanceIsOpen) return;
              txt.setStyle({ color: that.$color.mapTextColor });
              for (var i = 0; i < o.pols.length && i < 10; i++) {
                //只高亮前面最大的几个图形 其他小的忽略 提高性能
                o.pols[i].pol.setOptions({
                  fillColor: that.$color.mapColor,
                  fillOpacity: 0.8,
                });
              }
            });
            txt.on("mouseout", function () {
              console.log("执行成功");
              txt.setStyle({ color: that.$color.mapTextColor });
              for (var i = 0; i < o.pols.length && i < 10; i++) {
                o.pols[i].pol.setOptions({
                  fillColor: that.$color.mapColor,
                  fillOpacity: 0.5,
                });
              }
            });
            // map.add(lnglats);
          })();
        }
        map.setFitView();
      }
    },
  },
};
</script>
<style scoped lang="less">
.component-map-contaier {
  height: 100%;
}
#mapScreen {
  //   height: 1000px;
  // height: calc(~"100vh - 10%");
  // height: calc(~"100vh - 280px");
  width: 100%;
  height: 110%;
}
::v-deep(.amap-logo),
::v-deep(.amap-copyright) {
  display: none !important;
}
</style>
